export const categories = [
  {
    id: 'japanese-culture',
    name: '日本文化',
    slug: 'japanese-culture',
    description: '探索日本传统文化与现代文化的精髓，从茶道、花道到动漫、游戏文化的全方位解读。',
    icon: 'ri-building-2-line',
    color: 'primary',
    articleCount: 128,
  },
  {
    id: 'japanese-entertainment',
    name: '日本娱乐',
    slug: 'japanese-entertainment',
    description: '最新日本影视、音乐、综艺、动漫资讯，掌握日本娱乐圈第一手动向。',
    icon: 'ri-movie-2-line',
    color: 'accent',
    articleCount: 96,
  },
  {
    id: 'japanese-lifestyle',
    name: '日本生活',
    slug: 'japanese-lifestyle',
    description: '日本日常生活指南，涵盖美食、旅游、购物、家居等全方位生活资讯。',
    icon: 'ri-heart-line',
    color: 'primary',
    articleCount: 87,
  },
  {
    id: 'japanese-travel',
    name: '日本旅游',
    slug: 'japanese-travel',
    description: '日本各地旅游攻略，从北海道到冲绳，带您领略日本四季之美。',
    icon: 'ri-map-pin-line',
    color: 'accent',
    articleCount: 104,
  },
  {
    id: 'japanese-technology',
    name: '日本科技',
    slug: 'japanese-technology',
    description: '日本前沿科技资讯，人工智能、机器人、汽车制造等领域的创新动态。',
    icon: 'ri-cpu-line',
    color: 'primary',
    articleCount: 73,
  },
  {
    id: 'asian-integration',
    name: '亚洲融合',
    slug: 'asian-integration',
    description: '日本与亚洲各国文化交流与融合，区域合作与跨国文化碰撞。',
    icon: 'ri-global-line',
    color: 'accent',
    articleCount: 65,
  },
];

export const articles = [
  {
    id: 1,
    title: '京都千年古都：探访日本传统文化的灵魂之地',
    slug: 'kyoto-traditional-culture',
    category: 'japanese-culture',
    excerpt: '京都作为日本千年古都，承载着最深厚的日本传统文化底蕴。从金阁寺的庄严到伏见稻荷大社的神秘，每一处都讲述着日本历史的故事。',
    content: '京都是日本最具历史文化底蕴的城市之一……',
    coverImage: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20temple%20in%20Kyoto%20with%20cherry%20blossoms%2C%20golden%20pavilion%20reflection%20in%20pond%2C%20serene%20atmosphere%2C%20warm%20sunlight%2C%20minimalist%20Japanese%20aesthetic%2C%20soft%20natural%20colors%2C%20editorial%20travel%20photography&width=800&height=500&seq=article-kyoto-01&orientation=landscape',
    author: '山田花子',
    publishDate: '2026-08-10',
    readTime: 8,
    tags: ['京都', '传统文化', '寺庙', '历史'],
    featured: true,
  },
  {
    id: 2,
    title: '2026年日本动漫产业新趋势：从霸权番到全球化布局',
    slug: 'anime-industry-2026',
    category: 'japanese-entertainment',
    excerpt: '日本动漫产业在2026年迎来新一轮变革，流媒体平台的崛起改变了传统制作和分发模式，全球市场成为日本动漫的新增长引擎。',
    content: '日本动漫产业持续蓬勃发展……',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20anime%20studio%20workspace%20with%20digital%20drawing%20tablets%2C%20colorful%20animation%20cells%20on%20walls%2C%20creative%20atmosphere%2C%20warm%20indoor%20lighting%2C%20clean%20minimalist%20design%2C%20professional%20editorial%20photography&width=800&height=500&seq=article-anime-02&orientation=landscape',
    author: '佐藤健太',
    publishDate: '2026-08-08',
    readTime: 6,
    tags: ['动漫', '产业趋势', '流媒体', '全球化'],
    featured: true,
  },
  {
    id: 3,
    title: '东京米其林指南2026：必尝的十家三星餐厅',
    slug: 'tokyo-michelin-2026',
    category: 'japanese-lifestyle',
    excerpt: '2026年东京米其林指南新鲜出炉，这座城市继续蝉联全球米其林星级餐厅最多的城市。我们为您精选十家不可错过的顶级美食体验。',
    content: '东京美食界再创辉煌……',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20kaiseki%20cuisine%20presented%20on%20minimalist%20ceramic%20plates%2C%20warm%20restaurant%20ambient%20lighting%2C%20wooden%20counter%20seating%2C%20chef%20hands%20preparing%20dish%2C%20clean%20composition%2C%20soft%20shadows%2C%20fine%20dining%20photography&width=800&height=500&seq=article-michelin-03&orientation=landscape',
    author: '中村美咲',
    publishDate: '2026-08-05',
    readTime: 10,
    tags: ['美食', '米其林', '东京', '餐厅'],
    featured: true,
  },
  {
    id: 4,
    title: '北海道冬季自由行全攻略：从札幌到函馆的七天之旅',
    slug: 'hokkaido-winter-travel',
    category: 'japanese-travel',
    excerpt: '北海道冬季银装素裹，从札幌雪祭到函馆夜景，从登别温泉到小樽运河，七天完美行程带你领略北国风光。',
    content: '北海道是日本冬季旅游的首选目的地……',
    coverImage: 'https://readdy.ai/api/search-image?query=Hokkaido%20winter%20landscape%20with%20snow%20covered%20trees%20and%20traditional%20Japanese%20buildings%2C%20warm%20light%20from%20windows%2C%20snow%20falling%20gently%2C%20peaceful%20atmosphere%2C%20soft%20white%20and%20warm%20tones%2C%20travel%20editorial%20photography&width=800&height=500&seq=article-hokkaido-04&orientation=landscape',
    author: '田中一郎',
    publishDate: '2026-08-03',
    readTime: 12,
    tags: ['北海道', '冬季', '自由行', '攻略'],
    featured: false,
  },
  {
    id: 5,
    title: '日本机器人产业深度解析：从工业自动化到服务机器人的进化',
    slug: 'japan-robotics-2026',
    category: 'japanese-technology',
    excerpt: '日本作为全球机器人技术领导者，在2026年实现了从传统工业机器人向智能服务机器人的重大转型，人形机器人走进日常生活。',
    content: '日本机器人技术持续引领全球……',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20Japanese%20humanoid%20robot%20in%20a%20clean%20laboratory%20setting%2C%20white%20and%20metallic%20design%2C%20soft%20ambient%20lighting%2C%20researchers%20in%20background%2C%20minimalist%20tech%20aesthetic%2C%20professional%20editorial%20photography&width=800&height=500&seq=article-robot-05&orientation=landscape',
    author: '高桥翔太',
    publishDate: '2026-07-30',
    readTime: 9,
    tags: ['机器人', '科技', '自动化', 'AI'],
    featured: false,
  },
  {
    id: 6,
    title: '中日韩三国流行文化交融：K-pop、J-pop与C-pop的跨界合作',
    slug: 'asian-pop-culture-fusion',
    category: 'asian-integration',
    excerpt: '亚洲三大流行音乐市场——日本、韩国与中国之间的跨界合作日益频繁，亚洲一级内容平台深度解析这一文化融合趋势。',
    content: '亚洲流行文化的边界正在消融……',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20concert%20stage%20with%20colorful%20dynamic%20lighting%2C%20Asian%20pop%20music%20performance%2C%20energetic%20atmosphere%2C%20crowd%20silhouettes%2C%20warm%20and%20vibrant%20color%20palette%2C%20editorial%20music%20photography&width=800&height=500&seq=article-pop-06&orientation=landscape',
    author: '李美玲',
    publishDate: '2026-07-28',
    readTime: 7,
    tags: ['流行文化', '音乐', '跨界合作', '亚洲'],
    featured: false,
  },
  {
    id: 7,
    title: '日本茶道入门：从抹茶到煎茶的美学之旅',
    slug: 'japanese-tea-ceremony',
    category: 'japanese-culture',
    excerpt: '茶道是日本文化的精髓所在，这篇文章带您了解日本茶道的历史渊源、基本礼仪以及不同流派的独特美学。',
    content: '茶道（さどう/ちゃどう）是日本传统文化的核心……',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20tea%20ceremony%20setup%20with%20matcha%20bowl%20and%20bamboo%20whisk%2C%20tatami%20mat%20floor%2C%20simple%20flower%20arrangement%2C%20warm%20natural%20light%20from%20paper%20screen%2C%20serene%20minimalist%20composition%2C%20editorial%20photography&width=800&height=500&seq=article-tea-07&orientation=landscape',
    author: '山田花子',
    publishDate: '2026-07-25',
    readTime: 7,
    tags: ['茶道', '抹茶', '传统文化', '美学'],
    featured: false,
  },
  {
    id: 8,
    title: '东京迪士尼海洋全新园区2026开放：梦幻海洋之旅全攻略',
    slug: 'tokyo-disney-sea-2026',
    category: 'japanese-entertainment',
    excerpt: '东京迪士尼海洋全新主题园区将于2026年秋季盛大开幕，融合日本原创IP与迪士尼经典元素，打造独一无二的梦幻体验。',
    content: '东京迪士尼海洋度假区再度扩展……',
    coverImage: 'https://readdy.ai/api/search-image?query=Tokyo%20Disney%20Sea%20park%20with%20Mediterranean%20harbor%20view%2C%20colorful%20buildings%2C%20clear%20blue%20sky%2C%20happy%20atmosphere%2C%20clean%20composition%2C%20bright%20daytime%20photography%2C%20editorial%20travel%20style&width=800&height=500&seq=article-disney-08&orientation=landscape',
    author: '佐藤健太',
    publishDate: '2026-07-22',
    readTime: 8,
    tags: ['迪士尼', '东京', '主题乐园', '攻略'],
    featured: true,
  },
];

export const faqs = [
  {
    question: '亚洲一级日本内容导航平台是什么？',
    answer: '亚洲一级日本内容导航平台是一个专注于汇聚顶级亚洲与日本优质内容资源的综合性导航平台。我们通过专业的分级筛选机制，为用户提供高质量、精准分类的日本文化、娱乐、生活、旅游、科技等多领域内容，确保用户能够高效获取最优质的亚洲一级日本体验。',
  },
  {
    question: '平台内容是如何进行分级筛选的？',
    answer: '我们的内容分级筛选体系基于多重维度：内容原创性评估、来源权威性验证、用户反馈数据分析以及专业编辑团队审核。每篇内容都经过至少三道审核流程，按照一级（精华推荐）、二级（优质内容）、三级（基础内容）进行标注，确保用户看到的内容都是经过严格筛选的精品。',
  },
  {
    question: '平台涵盖哪些内容类别？',
    answer: '目前平台涵盖日本文化、日本娱乐、日本生活、日本旅游、日本科技以及亚洲融合六大核心类别。每个类别下设有细分标签，用户可以按需浏览。我们也在持续拓展更多内容领域，为用户提供更全面的亚洲一级内容服务。',
  },
  {
    question: '如何获取平台最新内容更新通知？',
    answer: '您可以通过订阅我们的资讯邮件来接收最新内容更新通知。此外，我们的首页"精选推荐"区域会实时更新最热门的内容，分类页面也会按时间排序展示最新文章。建议您将平台加入书签，方便随时访问。',
  },
  {
    question: '平台的内容来源是否可靠？',
    answer: '是的，所有内容均来自经过认证的权威信息源和专业创作者。我们的编辑团队会对每一篇内容的来源进行溯源验证，确保信息的真实性和准确性。对于转载内容，我们会明确标注原始出处和作者信息，尊重知识产权。',
  },
  {
    question: '平台是否提供日语学习相关资源？',
    answer: '目前我们的日本文化类别中包含与日语学习相关的文化背景内容。我们正在规划开设专门的日语学习频道，将涵盖从入门到进阶的学习资源、日本语能力测试备考资料以及实用的生活日语会话内容。',
  },
];